import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';

import {
    submitSearchFacet,
    toggleVisibleDropdownMenu,
} from '../Actions/FacetedSearch.action';

const FacetedSearchCompact = ({ facetFilters, onFacetChange }) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu } = useSelector((state) => state.facetedSearch);

    const renderOptions = (group, onFacetChange) => {
        return (
            <>
                {group.options &&
                    group.options.map(
                        (item, itemIndex, array) => (
                            <li
                                key={`${item.label}-${itemIndex}`}
                                className="faceted-search__item"
                                role="faceted-search-item"
                            >
                                <FacetedFilterCheckbox
                                    item={item}
                                    group={group}
                                    onFacetChange={
                                        onFacetChange
                                    }
                                />
                            </li>
                        )
                    )}
            </>
        )
    }

    const groupHeader = (group, visibleDropdownMenu) => {
        return (
            <div
                className={`faceted-search__group-header ${
                    visibleDropdownMenu.includes(group.id)
                        ? 'faceted-search__group-header--show-compact'
                        : ''
                }`}
                role="faceted-search-item-group"
                onClick={(event) =>
                    dispatch(
                        toggleVisibleDropdownMenu(group)
                    )
                }
            >
                {group.label}
            </div>
        );
    }

    const renderConfirmButton = (facetFilters, group) => {
        return (
            <li className="faceted-search__item">
                <button
                    className="filter__button"
                    onClick={(event) => {
                        dispatch(
                            toggleVisibleDropdownMenu(
                                group
                            )
                        );
                        dispatch(
                            submitSearchFacet(
                                facetFilters
                            )
                        );
                    }}
                >
                    {translate('general.select')}
                </button>
            </li>
        );
    }

    const sortByName = (a, b) => {
        if ( a.id < b.id ){
            return -1;
        }
        if ( a.id > b.id ){
            return 1;
        }
        return 0;
    }

    facetFilters.forEach(function(elem) {
        if (elem.id === 'Brand') {
            elem.options.sort(sortByName);
        }
    });

    const groupSpecialDiet = (renderedFacetFilters) => {
        if (!renderedFacetFilters.length) return renderedFacetFilters;

        /**
         * Make sure groupedFilter and groupedFilterItems properties exists on all items.
         */
        renderedFacetFilters.map(filterItem => {
            filterItem.dietFilterItems = [];
            return filterItem;
        });

        let specialDietFilters = renderedFacetFilters.filter(x => x.isSpecialDiet);
        let remainingFilters = renderedFacetFilters.filter(function(filterItem) {
            return filterItem.isSpecialDiet != true;
        });

        if (!specialDietFilters.length) return remainingFilters;

        remainingFilters.push({
            id: 'Specialkost',
            isSpecialDiet: true,
            dietFilterItems: specialDietFilters,
            label: 'Specialkost',
            options: [],
            selectedOptions: [],
            singleSelect: false,
        });

        return remainingFilters;
    }

    let renderedFacetFilters = [...facetFilters];
    renderedFacetFilters = groupSpecialDiet(renderedFacetFilters);

    return (
        <ul className="faceted-search faceted-search--compact row">
            {renderedFacetFilters &&
                renderedFacetFilters.map(
                    (group, groupIndex) =>
                        group.dietFilterItems.length ? (
                            group.dietFilterItems &&
                            group.dietFilterItems.length > 0 && (
                                <li
                                    className="columns small-6 large-3 faceted-search__group"
                                    key={`${group.label}-${groupIndex}`}
                                >
                                    {groupHeader(group, visibleDropdownMenu)}
                                    <ul className="faceted-search__sublist">
                                        {group.dietFilterItems.map((subGroup, subGroupIndex) => (
                                            <div key={'subgroup' + subGroupIndex}>
                                                {renderOptions(subGroup, onFacetChange)}
                                            </div>
                                        ))}
                                        {renderConfirmButton(facetFilters, group)}
                                    </ul>
                                </li>
                            )
                        ) : (
                            group.options &&
                            group.options.length > 0 && (
                                <li
                                    className="columns small-6 large-3 faceted-search__group"
                                    key={`${group.label}-${groupIndex}`}
                                >
                                    {groupHeader(group, visibleDropdownMenu)}
                                    <ul className="faceted-search__sublist">
                                        {renderOptions(group, onFacetChange)}
                                        {renderConfirmButton(facetFilters, group)}
                                    </ul>
                                </li>
                            )
                        )
                )}
        </ul>
    );
};

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && item.quantity > 0 && (
                <span className="faceted-filter__quantity">
                    {' '}
                    ({item.quantity})
                </span>
            )}
        </span>
    </label>
);

export default FacetedSearchCompact;
